module.exports = __webpack_public_path__ + "static/Mariana-6db95fd8f8d237cc18edb4a4cc5fdc95.jpg";